import { Component, Input } from '@angular/core';
import { GenericFieldDirective } from '../../directives/generic-field/generic-field.directive';
import { TitleForm } from '../../interfaces/forms/form-element';

@Component({
    selector: 'app-title-form',
    templateUrl: './title-form.component.html',
    styleUrls: ['./title-form.component.scss'],
    standalone: false
})
export class TitleFormComponent extends GenericFieldDirective {
  @Input() override field!: TitleForm;
}
